module.exports = __webpack_public_path__ + "img/IMG_1156_L_Foamcore_MockedUp.0e5b44a4.jpg";